import { defineMessages } from '@jutro/locale';

export default defineMessages({
    PropertyInvolved: {
        id: 'ml.claim.views.ml-claim-details-property.Property Involved',
        defaultMessage: 'Property Involved'
    },
    YourHome: {
        id: 'ml.claim.views.ml-claim-details-property.Your Home',
        defaultMessage: 'Your Home'
    }
});
